module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門1_6_2.3b085ec9.png";